// import { ApiErrorData } from './service';

import axios, {AxiosResponse} from 'axios';
import { ErrorCodeKey } from './errorCode';

type ApiErrorDataCont = {
  displayableMessage: boolean | null,
  errorCode: ErrorCodeKey | null,
  errorMessageArgs: string | null,
  exceptionClassName: string | null,
  filed: string | null,
  message: string | null,
  object: string | null,
}

export type ApiErrorData = {
  result:  ApiErrorDataCont | ApiErrorDataCont[]
}

// CBT 신청
export function callApplyCbt(data: RequestPostCbtRecord):Promise<AxiosResponse<ResponsePostCbtRecord>>{
  return axios({
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/cbt/record',
    data
  });
}


// CBT 신청 조회
export function callCheckCbtApplyStatus(eventCode: string):Promise<AxiosResponse<ResponseGetCbtRecord>>{
  return axios({
    method: 'get',
    headers: {
      'content-type': 'application/json',
    },
    responseType: 'json',
    url: '/api/cbt/record',
    params: {
      eventCode
    }
  });
}

// 본인 인증 요청 문자열 생성
export function callCreateAuthRequest(data: RequestPostSelfcertPhoneCreateAuthRequest):Promise<AxiosResponse<ResponsePostSelfcertPhoneCreateAuthResponse>>{
  return axios({
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/selfcert/phone/createAuthRequest',
    data
  });
}

// 본인 인증 결과 확인
export function callCheckAuth(data: RequestPostSelfcertPhoneCheckAuth):Promise<AxiosResponse<ResponsePostSelfcertPhoneCheckAuth>>{
  return axios({
    method: 'post',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'json',
    url: '/api/selfcert/phone/checkAuth',
    data
  });
}


// 설문조사 저장?


// [TODO] 삭제
// CBT 신청 데이터 삭제 (라이브망 제외, 개발용)
